import type { FeedEntry, UIComponent } from '~/services/layout';
import { isGroupInfo } from './helpers';
import logger from '~/services/logger';

export function getGroupComponentsAndFeedEntries({
  feed,
  uiComponents,
  uiComponentsLimits,
}: {
  feed: any;
  uiComponents: UIComponent[];
  uiComponentsLimits: number[];
}): {
  uiComponent: UIComponent;
  feedEntry: FeedEntry[];
}[] {
  try {
    const res: {
      uiComponent: UIComponent;
      feedEntry: FeedEntry[];
    }[] = [];

    let currentOffset = 0;

    let isFeedExhausted = false;

    uiComponents.forEach((c: UIComponent, index) => {
      if (isGroupInfo(c)) {
        res.push({
          uiComponent: c,
          feedEntry: feed.entry,
        });
        return;
      }

      if (isFeedExhausted) return;

      const limit = uiComponentsLimits[index];

      const startSlice = currentOffset;
      let endSlice;

      if (limit && limit > 0) {
        endSlice = startSlice + limit;
        currentOffset += limit;
      } else {
        endSlice = undefined;
        isFeedExhausted = true;
      }

      res.push({
        uiComponent: c,
        feedEntry: feed.entry.slice(startSlice, endSlice),
      });
    });

    return res;
  } catch (error: any) {
    logger.error(`getGroupComponentsAndFeedEntries: ${error.message}`);
    return [];
  }
}
